import React from 'react';

const Arrow = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      {...props}
    >
      <g clip-path='url(#clip0_6008_565010)'>
        <path
          d='M3 11L8 6L3 1'
          stroke='#011211'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6008_565010'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='matrix(-1 8.74228e-08 8.74228e-08 1 12 0)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Arrow;
